import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faStamp } from '@fortawesome/pro-regular-svg-icons';
import { ButtonTW } from '../../../../../tailwindComponents/buttonTW/ButtonTW';
import { Show } from '../../../../shared/Show';
import { eSigningMethod } from '../../../../../types/signingAppointment/eSigningMethod';
import { SigSyncConfirmationModal } from './SigSyncConfirmation/SigSyncConfirmationModal';
import { useSelectAppointmentFromPathParam } from '../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { attorneyOrNotary } from '../../../../../utilities/order/scheduling/attorneyOrNotary';

export interface NoNotaryAssignedProps {
  onUpdateNotaryClick: () => void;
}

export const NoNotaryAssigned = ({ onUpdateNotaryClick }: NoNotaryAssignedProps) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const [showSigSyncConfirmationModal, setShowSigSyncConfirmationModal] = useState(false);

  const onSigSyncClick = () => setShowSigSyncConfirmationModal(true);
  const onCloseSigSyncModal = () => setShowSigSyncConfirmationModal(false);

  if (
    !appointmentFromPath ||
    (appointmentFromPath.isDigitalScheduling && !appointmentFromPath.isDigitalSchedulingDraft)
  ) {
    return null;
  }

  return (
    <>
      <SigSyncConfirmationModal
        show={showSigSyncConfirmationModal}
        onClose={onCloseSigSyncModal}
      />
      <div className="flex flex-col justify-center">
        <section className="flex flex-col justify-center gap-2">
          <div className="flex justify-center">
            <FontAwesomeIcon
              className="h-12 w-12 text-extension-foundation-primary-variant"
              icon={faStamp}
            />
          </div>
          <div className="flex justify-center">
            <span className="font-medium text-black">
              {`Assign ${attorneyOrNotary(appointmentFromPath.signingMethod)}`}
            </span>
          </div>
          <div className="flex justify-center gap-3">
            <Show when={appointmentFromPath.signingMethod === eSigningMethod.notaryOnly}>
              <ButtonTW onClick={onSigSyncClick}>
                <span className="mr-1">
                  <FontAwesomeIcon icon={faPlus} />
                </span>
                Signature Sync
              </ButtonTW>
            </Show>

            <Show
              when={
                appointmentFromPath.signingMethod !== eSigningMethod.notaryOnly ||
                !appointmentFromPath.isDigitalScheduling
              }
            >
              <ButtonTW secondary onClick={onUpdateNotaryClick}>
                <span className="mr-1">
                  <FontAwesomeIcon icon={faPlus} />
                </span>
                Add New
              </ButtonTW>
            </Show>
          </div>
        </section>
      </div>
    </>
  );
};
